export const SA_PERMISSIONS = [
  'sa_overview',
  'sa_leads',
  'sa_companies',
  'sa_plans',
  'sa_earnings',
  'sa_trials',
  'sa_notifications',
  'sa_support',
  'sa_prospects',
  'sa_email_templates',
  'sa_health',
];

export const SA_PERMISSION_GROUPS = [
  {
    id: 'core',
    label: 'Core',
    permissions: [
      { key: 'sa_overview',   label: 'Overview Dashboard', description: 'Platform-wide KPIs and stats' },
      { key: 'sa_companies',  label: 'Companies',          description: 'View and manage all client companies' },
      { key: 'sa_plans',      label: 'Plans',              description: 'Manage pricing plans and features' },
      { key: 'sa_earnings',   label: 'Earnings',           description: 'Revenue and billing reports' },
      { key: 'sa_trials',     label: 'Trials',             description: 'Trial accounts and conversions' },
    ],
  },
  {
    id: 'growth',
    label: 'Growth & Sales',
    permissions: [
      { key: 'sa_leads',           label: 'Leads',           description: 'Inbound leads and demo requests' },
      { key: 'sa_prospects',       label: 'Prospects',       description: 'B2B prospect pipeline and drip sequences' },
      { key: 'sa_email_templates', label: 'Email Templates', description: 'Drip email templates and variables' },
    ],
  },
  {
    id: 'ops',
    label: 'Operations',
    permissions: [
      { key: 'sa_notifications', label: 'Notifications', description: 'Platform notification feed' },
      { key: 'sa_support',       label: 'Support',       description: 'Customer support tickets' },
      { key: 'sa_health',        label: 'System Health', description: 'Server, DB, cron job monitoring' },
    ],
  },
];

/** Returns true if the user can see the given SA section. */
export function hasSAPermission(user, key) {
  if (!user) return false;
  if (user.role === 'super_admin') return true;
  if (user.role === 'echohire_staff') {
    return Array.isArray(user.saPermissions) && user.saPermissions.includes(key);
  }
  return false;
}
